import React from 'react';
import { Select, DropdownItemProps } from 'vendors/semantic-ui';
import { FilterValue } from 'modules/shared/models';
import { removeAccent } from 'modules/shared/utils';
import { CollectionPickerProps } from './collection-picker-type';

import styles from './collection-picker-component.module.css';

const buildCollectionOptions = (collections: FilterValue[]): DropdownItemProps[] => {
    const result = [{ key: '0', value: 0, text: 'Toutes les collections' }];

    return result.concat(
        collections
            .sort((a: FilterValue, b: FilterValue) => {
                const formattedA = removeAccent(a.displayName);
                const formattedB = removeAccent(b.displayName);
                return formattedA.charCodeAt(0) - formattedB.charCodeAt(0);
            })
            .map(collection => {
                return { key: collection.displayName, value: collection.value, text: collection.displayName };
            }),
    );
};

export const CollectionPicker: React.FC<CollectionPickerProps> = React.memo(
    ({ collections, selectedValue, onChange }: CollectionPickerProps) => {
        if (collections && collections.length > 0) {
            const collectionOptions = buildCollectionOptions(collections);
            return (
                <Select
                    className={`${styles.selector} custom-selector`}
                    defaultValue={selectedValue}
                    options={collectionOptions}
                    onChange={(item, ddprops) => {
                        onChange(Number(ddprops.value));
                    }}
                    style={{ fontSize: '1.6rem' }}
                />
            );
        }
        return <React.Fragment></React.Fragment>;
    },
);
